import { Text, TextProps } from '@chakra-ui/react';
import { Trans } from 'react-i18next';
import { commonConfig } from '../../../../../core/config';

export const Terms = ({ ...rest }: TextProps) => {
  return (
    <Text textAlign="center" color="gray.900" fontSize="sm" {...rest}>
      <Trans i18nKey="auth.agreeToTerms">
        <Text
          as="a"
          href={commonConfig.links.terms}
          target="_blank"
          rel="noopener noreferrer"
          fontWeight="bold"
        />
        <Text
          as="a"
          href={commonConfig.links.privacy}
          target="_blank"
          rel="noopener noreferrer"
          fontWeight="bold"
        />
      </Trans>
    </Text>
  );
};
